module.exports = __webpack_public_path__ + "media/images/admin/icons/refresh-ccw-f0e1217c1b825cb980e255924d718e86.svg";